import { styled } from '@mui/material/styles';

export const StyledRichText = styled('div')(({ theme, hasFocus, error, disabled }) => ({
  ...(hasFocus && {
    borderColor: theme.color.primary.main,
    boxShadow: `0px 0px 0px 1px ${error ? theme.color.danger.main : theme.color.primary.main}`
  }),
  ...(error && {
    borderColor: theme.color.danger.main
  }),
  '&:hover': {
    ...(!disabled && !error && !hasFocus && {
      borderColor: theme.color.grey[700]
    })
  }
}));
